import { Component, ElementRef, Input, OnDestroy, ViewChild } from "@angular/core";
import { NbMenuService } from "@nebular/theme";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

@Component({
    selector: "kno2-control-panel-container",
    templateUrl: "./control-panel-container.component.html",
    styleUrls: ["./control-panel-container.component.scss"],
    standalone: false
})
export class ControlPanelContainerComponent implements OnDestroy {
    @ViewChild("controlPanel", {
        read: ElementRef
    })
    public controlPanel: ElementRef;
    @Input() public sidebarMenuName: string;
    private subscriptions: Array<Subscription> = [];

    constructor(private menuService: NbMenuService) {
        this.subscriptions.push(
            this.menuService
                .onItemClick()
                .pipe(filter(({ tag: menuName }) => menuName === this.sidebarMenuName))
                .subscribe((clickedItem) => {
                    // todo: handle scroll to logic
                    console.log("menu click registered in control panel container: ", clickedItem);
                })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
